import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import { getRequestStats } from '../redux/action/request';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { RefreshCw } from 'lucide-react';
import {
  getAllRequestList,
  getRequestStatsByStatus,
} from '../redux/action/request'; // Use an existing action
import { useNavigate } from 'react-router-dom';

import { motion } from 'framer-motion';
const RenewPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { requestStats } = useSelector((state) => state.auth);
  const { requestByStatus } = useSelector((state) => state.auth);
  const quotationDetail = useSelector(
    (state) => state.yourReducer?.quotationDetail || []
  );

  const handleDownload = (url) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    dispatch(getRequestStats());
    dispatch(getAllRequestList());
    dispatch(getRequestStatsByStatus());
  }, [1000]);

  console.log(requestStats, "requestStatsrequestStatsrequestStatsrequestStats")
  return (
    <div className='flex flex-col min-h-screen bg-gray-50'>
      <ToastContainer />
      <Header />
      <div className='flex flex-col items-center justify-center py-10'>
        
        

        {/* Cards Container */}
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4'>
          {/* Card 1 */}
          <div className='bg-white shadow-md rounded-2xl p-6 flex flex-col items-center'>
            <button className='bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600'>
              {requestStats?.totalRequests}
            </button>
            <h2 className='text-xl font-semibold mb-2'>Total policies</h2>
            <p className='text-gray-600 text-center mb-4'>
              Leads whose Admin uploaded policies for you
            </p>
          </div>

          {/* Card 2 */}
          <div className='bg-white shadow-md rounded-2xl p-6 flex flex-col items-center'>
            <button className='bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600'>
              {requestStats?.totalActiveRequests}
            </button>
            <h2 className='text-xl font-semibold mb-2'>Active policies</h2>
            <p className='text-gray-600 text-center mb-4'>
              Leads whose uploaded policies are yet active.
            </p>
          </div>

          {/* Card 3 */}
          <div className='bg-white shadow-md rounded-2xl p-6 flex flex-col items-center'>
            <button className='bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600'>
              {requestStats?.totalExpiredRequests}
            </button>
            <h2 className='text-xl font-semibold mb-2'>Expire policies</h2>
            <p className='text-gray-600 text-center mb-4'>
              Leads whose uploaded policies are not yet active.
            </p>
          </div>
        </div>
        {/* Table */}
        {/* Table */}
        <div className='w-full px-12 mt-8'>
          <h2 className='text-xl font-semibold mb-4'>Policy Details</h2>
          <div className='overflow-x-auto'>
            <table className='min-w-full bg-white border rounded-lg shadow-md'>
              <thead>
                <tr className='bg-green-500 text-white'>
                  <th className='py-2 pl-6 pr-6'>Company</th>
                  <th className='py-2 pl-6 pr-6'>Status</th>
                  <th className='py-2 pl-6 pr-6'>Policy Expiry date</th>
                  <th className='py-2 pl-6 pr-6'>Premium Amount</th>
                  <th className='py-2 pl-6 pr-6'>Policy</th>
                  <th className='py-2 pl-6 pr-6'>Review</th>
                </tr>
              </thead>
              <tbody>
                
                { requestByStatus && requestByStatus?.map((form, index) => (
                  <tr
                    key={index}
                    className='border-t'
                  >
                    <td className='py-2 pl-6 pr-6 text-center'>
                      {form?.paymentDetail?.companyLogo ? (
                        <span className='flex items-center space-x-4'>
                          <img
                            src={form?.paymentDetail?.companyLogo}
                            alt='Company Logo'
                            className='w-14 h-14 rounded-full border border-gray-300 object-cover'
                          />
                          <small className='text-sm text-gray-600'>
                            {form?.paymentDetail?.companyName}
                          </small>
                        </span>
                      ) : (
                        ''
                      )}
                    </td>
                    <td className='py-2 pl-6 pr-6 text-center'>
                      {new Date(form.policyExpire) < new Date()
                        ? <span className='text-[red]'>Expire</span>
                        : <span className='text-[green]'>Active</span>}
                    </td>

                    <td className='py-2 pl-6 pr-6 text-center'>
                      {form.policyExpire
                        ? new Date(form.policyExpire).toLocaleDateString()
                        : 'N/A'}
                    </td>
                    <td className='text-center text-xs'>
                      <span className=' py-2 pl-6 pr-6 bg-[#193345] text-center text-[white] py-1 px-2 rounded'>
                        {form.paymentDetail?.premiumAmount}
                      </span>
                    </td>
                    

                    <td className='text-center text-xs'>
                      <button
                        onClick={() => handleDownload(form.policyUrl)}
                        className='py-2 pl-6 pr-6 bg-[#193345] text-center text-white py-1 px-2 rounded'
                      >
                        Download
                      </button>
                    </td>

                    <td className='py-2 pl-6 pr-6 text-center'>
                      {new Date(form.policyExpire) < new Date() ? (
                        <button
                          className='underline'
                          onClick={() => {
                            navigate(`/quotation`, { state: form });
                            localStorage.setItem('review', true);
                          }}
                        >
                          Renew Now
                        </button>
                      ) : (
                        ''
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewPage;
